import * as React from 'react';

import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';

import { blockButtonVariants } from '@shared/components/variants/blockButton.variants';
import { cn } from '@shared/utils';

interface ButtonProps extends React.ComponentPropsWithRef<'button'>, VariantProps<typeof blockButtonVariants> {
  asChild?: boolean;
  loading?: boolean;
}

export const BlockButton = ({
  className,
  variant,
  size,
  asChild = false,
  loading = false,
  disabled,
  children,
  ref,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      className={cn(blockButtonVariants({ variant, size, className }))}
      ref={ref}
      disabled={disabled ?? loading}
      {...props}
    >
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Comp>
  );
};

BlockButton.displayName = 'BlockButton';
